module.exports = __webpack_public_path__ + "static/media/flag-fr.0dd46420.webp";